import React from 'react'

import { ButtonProps } from '@material-ui/core'

import useLogout from '~/auth/hooks/useLogout'
import { B2CModal } from '~/ui/components'

interface LogoutProps {
  open: boolean
  onClose?: () => void
}

const LogoutModal: React.FC<LogoutProps> = ({ open = false, onClose = () => 0 }) => {
  const logout = useLogout()

  const actions = [
    {
      id: 'close',
      name: 'Sí, cerrar sesión',
      onClick: () => {
        onClose()
        logout()
      },
    },
    {
      id: 'cancel',
      button: { variant: 'outlined' } as ButtonProps,
      name: 'cancelar',
      onClick: () => {
        onClose()
      },
    },
  ]

  return (
    <B2CModal
      dataHook="logout-modal"
      isOpen={open}
      type="warning"
      title="¿Estás seguro que quieres Cerrar sesión?"
      onClose={onClose}
      actions={actions}
    />
  )
}

export default LogoutModal
